
import React from 'react';
import { Calendar, Button, Row, Icon, List, Avatar} from 'antd';

import moment from 'moment';
import { description } from '../admin/events/Constants';
import Badge from './Badge';
import { IMAGES_URL } from '../../helper/api/Api';

export default class CalendarEvent extends React.Component {
  state = {
    mode: 'month',
    value: moment(),
    isZoom: false
  }

  dateCellRender = (date) => {
    const events = this.props.event.calendarList
      .filter(e => 
        moment(e.openAt).isSameOrBefore(moment(date), 'day')
        && moment(e.closeAt).isSameOrAfter(moment(date), 'day')
      );

    if (this.state.isZoom && date.isSame(this.state.value, 'day'))
      return (
        <div>
          <Icon type="close" onClick={(e) => { e.stopPropagation(); this.setState({ isZoom: false })}} style={{ position: "absolute", top: 13, left: 13}}/>
          <List
            itemLayout="horizontal"
            dataSource={events}
            renderItem={(event, index) => (
              <List.Item key={index} actions={[<Button type="primary" shape="circle" icon="eye" theme="filled" onClick={() => this.props.showModal(true, event.id)}/>]}>
                <List.Item.Meta
                  avatar={<Avatar src={IMAGES_URL(event.images)} />}
                  title={<Badge event={event} />}
                  description={event.description}
                />
              </List.Item>
            )}
          />
        </div>
      );

    return (
      <ul className="events">
        {
          events.map(event => (
            <li key={event.id}>
              <Badge event={event} />
            </li>
          ))
        }
      </ul>
    );
  }
  
  monthCellRender = (date) => {
    const events = this.props.event.calendarList.filter(e =>  
      moment(e.openAt).isSameOrBefore(moment(date), 'month')
      && moment(e.closeAt).isSameOrAfter(moment(date), 'month')) || [];
  
    return events.length > 0 ? (
      <div className="notes-month">
        <section>{events.length} <span>Événement{events.length > 1 ? 's' : null }</span></section>
      </div>
    ) : null;
  }
  
  onSelect = (date) => {
    this.setState({ value: date })
    if(this.state.mode === "year")
      return this.setState({ mode : "month", isZoom: false});
    else
      this.setState({ isZoom: true })

    /*const events = this.props.event.list
      .filter(e => 
        moment(e.openAt).isSameOrBefore(moment(date), 'day')
        && moment(e.closeAt).isSameOrAfter(moment(date), 'day'));*/
  
    //this.props.onSelect(events.map(e => e.id));
  }
  

  render() {
    return (<Calendar
              className={this.state.isZoom ? "calendar-with-zoom" : ''}
              mode={ this.state.mode }
              value={ this.state.value }
              onSelect={(date) => this.onSelect(date)} 
              dateCellRender={(date) => this.dateCellRender(date)} 
              monthCellRender={(date) => this.monthCellRender(date)} 
              onPanelChange={(value, mode) => this.setState({ value, mode })}/>);
  }
}


// WEBPACK FOOTER //
// ./src/features/event/Calendar.js